class ABTest {
  constructor() {
    this.features = []
    this.isReady = false
  }

  addTest(test) {
    this.features.push(test)
    if (this.isReady) {
      test.run(this.growthbook)
      console.log("Test added after AB Testing was ready")
    }
  }

  run() {
    this.features.forEach((test) => {
      test.run(this.growthbook)
    })
  }

  setReady() {
    console.log("AB Testing is ready")
    if (this.isReady) return
    this.isReady = true
    this.growthbook = window._growthbook
    this.run()
  }
}

class SelectorChanges {
  constructor(selector, properties = {}, classes = []) {
    this.selector = selector;
    this.properties = properties;
    this.classes = classes;
  }

  addProperty(property, value) {
    this.properties[property] = value;
  }

  addClass(className) {
    this.classes.push(className);
  }
}

class BooleanFeature {
  constructor(featureFlag, options = {}) {
    this.featureFlag = featureFlag
    this.isRunning = false
    this.default = options.default || []
    this.variation = options.variation || []
  }

  applyChanges(changes) {
    if (!changes) {
      return
    }
    changes.forEach((change) => {
      const elements = document.querySelectorAll(change.selector)
      elements.forEach((element) => {
        // Apply styles
        Object.keys(change.properties).forEach((property) => {
          element.style[property] = change.properties[property]
        })
        // Apply classes
        change.classes.forEach((className) => {
          element.classList.add(className)
        })
      })
    })
  }

  run(growthbook) {
    console.log(`Feature ${this.featureFlag}`)

    if (this.isRunning) {
      console.log("Test is already running.")
      return
    }
    this.isRunning = true
    this.isOn = growthbook.isOn(this.featureFlag)

    if (this.isOn) {
      this.applyChanges(this.variation)
    } else if (this.default.length > 0) {
      this.applyChanges(this.default)
    }

    console.log(`Feature ${this.featureFlag} is running: ${this.isOn}`)
  }
}

const abTest = new ABTest()

/* ******************** */
/* ----- Testing ------ */
/* ******************** */

// quantity button test

const quantityButtonNew = [
  new SelectorChanges(".qtty-variation-old", {
    display: "none",
  }),
  new SelectorChanges(".qtty-variation-new", {
    display: "flex",
  }),
]

const quantityButtonFeature = new BooleanFeature("24-10-18--quantity-select", {
  default: [],
  variation: quantityButtonNew,
})

const listViewVariation = [new SelectorChanges("#AjaxinateContainer", {}, ["list-view--collection"])]

const listViewFeature = new BooleanFeature("24-11-26--collection--list-view", {
  default: [],
  variation: listViewVariation,
})

abTest.addTest(quantityButtonFeature)
abTest.addTest(listViewFeature)

// ATC button color test

// const ATCvariationChanges = [
//   new SelectorChanges("#kalender-atc", {
//     background: "#E31823",
//   }),
//   new SelectorChanges(".atc-container button", {
//     background: "#E31823",
//   }),
// ]

// const ATCFeature = new BooleanFeature("24-09-20--kalender-atc--color", {
//   default: [],
//   variation: ATCvariationChanges,
// })

// abTest.addTest(ATCFeature)

// Announcement bar test

// const announcementBarVariation = [
//   new SelectorChanges(".announcement-bar", {
//     display: "block",
//   }),
// ]

// const announcementBarFeature = new BooleanFeature("25-09-25--kalender-announcement--display", {
//   default: [],
//   variation: announcementBarVariation,
// })

// abTest.addTest(announcementBarFeature)

/* ******************** */
/* ---- TestingEND ---- */
/* ******************** */

// State object to track event firing
const eventState = {
  domContentLoaded: false,
  growthbookScriptLoaded: false,
}

// Function to check if both events have fired
function checkReady() {
  if (window._growthbook) eventState.growthbookScriptLoaded = true
  if (eventState.domContentLoaded && eventState.growthbookScriptLoaded) {
    abTest.setReady()
  } else {
    console.log("Not ready yet")
  }
}
// Event listener for DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => {
//   console.log("DOMContentLoaded -- ABTesting.js")
  eventState.domContentLoaded = true
  checkReady()
})
// Event listener for growthbookScriptLoaded
document.addEventListener("ABScriptLoaded", () => {
//   console.log("ABScriptLoaded -- ABTesting.js")
  eventState.growthbookScriptLoaded = true
  checkReady()
})
